import emptyState from "./emptyState";
import { actionTypes } from "./actions";
import { immutableSet } from "../../../../utils/immutable";
import { IAction } from "../../../../models/Action";
import { compose } from "redux";
import { IResponseState } from "../../../../components/Modals/ResponseModal/module/constants";
import { STATE_IDENTIFIER } from "./constants";

const {
  STEP_ONE,
  SELECTED_TYPE,
  CONFIGURE_TABLES,
  DATA_IDENTIFIER,
  VISIBLE_IDENTIFIER,
  POSITION_IDENTIFIER,
  LOADER_IDENTIFIER,
  CALL_STATE,
  COLUMNS_IDENTIFIER,
} = STATE_IDENTIFIER;

const ACTION_HANDLERS = {
  [actionTypes.SET_SELECTED_TYPE]: (state: any, action: any) =>
    compose(
      immutableSet([STEP_ONE, SELECTED_TYPE], action.payload),
      immutableSet([CALL_STATE], IResponseState.PENDING)
    )(state),

  [actionTypes.GET_TABLES_CONFIGURATION_MANAGEMENT_DATA]: (
    state: any,
    action: any
  ) =>
    compose(immutableSet([CONFIGURE_TABLES, LOADER_IDENTIFIER], true))(state),
  [actionTypes.GET_TABLES_CONFIGURATION_MANAGEMENT_DATA_SUCCESS]: (
    state: any,
    action: any
  ) => {
    const tablesData = action.payload;
    let transformedTableData = tablesData.reduce(
      (array: any, value: any) => ({
        ...array,
        [value.idTable]: {
          idTable: value.idTable,
          section: value.section,
          type: value.type,
          columns: {
            ...value.columns.reduce(
              (array: any, value: any) => ({ ...array, [value.key]: value }),
              {}
            ),
          },
        },
      }),
      {}
    );
    return compose(
      immutableSet([CONFIGURE_TABLES, DATA_IDENTIFIER], transformedTableData),
      immutableSet([CONFIGURE_TABLES, LOADER_IDENTIFIER], false)
    )(state);
  },
  [actionTypes.GET_TABLES_CONFIGURATION_MANAGEMENT_DATA_FAILURE]: (
    state: any,
    action: any
  ) =>
    compose(immutableSet([CONFIGURE_TABLES, LOADER_IDENTIFIER], false))(state),

  [actionTypes.UPDATE_TABLES_CONFIGURATION]: (state: any, action: any) =>
    compose(immutableSet([CALL_STATE], IResponseState.PENDING))(state),
  [actionTypes.UPDATE_TABLES_CONFIGURATION_SUCCESS]: (
    state: any,
    action: any
  ) => compose(immutableSet([CALL_STATE], IResponseState.SUCCESS))(state),
  [actionTypes.UPDATE_TABLES_CONFIGURATION_FAILURE]: (
    state: any,
    action: any
  ) => compose(immutableSet([CALL_STATE], IResponseState.ERROR))(state),

  [actionTypes.SET_IS_COLUMN_VISIBLE]: (
    state: any,
    action: {
      type: string;
      payload?: { isVisible: boolean; columnName: string; tableKey: string };
    }
  ) =>
    immutableSet(
      [
        CONFIGURE_TABLES,
        DATA_IDENTIFIER,
        action.payload!.tableKey,
        COLUMNS_IDENTIFIER,
        action.payload!.columnName,
        VISIBLE_IDENTIFIER,
      ],
      action.payload!.isVisible,
      state
    ),

  [actionTypes.SET_COLUMN_ORDER]: (
    state: any,
    action: {
      type: string;
      payload?: { newOrder: string; columnName: string; tableKey: string };
    }
  ) =>
    immutableSet(
      [
        CONFIGURE_TABLES,
        DATA_IDENTIFIER,
        action.payload!.tableKey,
        COLUMNS_IDENTIFIER,
        action.payload!.columnName,
        POSITION_IDENTIFIER,
      ],
      action.payload!.newOrder,
      state
    ),
};

export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  if (
    action &&
    action.type === "@@router/LOCATION_CHANGE" &&
    (action.payload.location.pathname === "/welcome" ||
      action.payload.location.pathname === "/admin" ||
      action.payload.location.pathname ===
        "/admin-tables-configuration-management")
  ) {
    return emptyState;
  }
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
